"use strict";
// CSS align-items property evaluator
// Handles CSS align-items property values according to MDN specification
// https://developer.mozilla.org/en-US/docs/Web/CSS/align-items
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
exports.toCSSValue = toCSSValue;
const shared_utils_1 = require('../utils/shared-utils.cjs');
const css_variable_1 = require('./css-variable.cjs');
// Import and re-export centralized types
const types_1 = require('../types.cjs');
// Use imported keyword arrays
const BASIC_KEYWORDS = types_1.BASIC_ALIGNMENT_KEYWORDS;
const POSITIONAL_KEYWORDS = types_1.POSITIONAL_ALIGNMENT_KEYWORDS;
const BASELINE_KEYWORDS = types_1.BASELINE_ALIGNMENT_KEYWORDS;
const OVERFLOW_KEYWORDS = types_1.OVERFLOW_ALIGNMENT_KEYWORDS;
// All valid alignment values (excluding overflow combinations)
const ALL_ALIGNMENT_VALUES = [
    ...BASIC_KEYWORDS,
    ...POSITIONAL_KEYWORDS,
    ...BASELINE_KEYWORDS
];
function parse(input) {
    if (!input || typeof input !== 'string') {
        return null;
    }
    const trimmed = input.trim();
    if (trimmed === '') {
        return null;
    }
    // CSS variables can be parsed directly
    if ((0, shared_utils_1.isCssVariable)(trimmed)) {
        return (0, css_variable_1.parse)(trimmed);
    }
    // Handle global keywords
    if ((0, shared_utils_1.isGlobalKeyword)(trimmed)) {
        return { type: 'keyword', keyword: trimmed.toLowerCase() };
    }
    // Handle overflow alignment (e.g., "safe center", "unsafe flex-start")
    const tokens = trimmed.toLowerCase().split(/\s+/);
    if (tokens.length === 2) {
        const [modifier, alignment] = tokens;
        const validModifier = (0, shared_utils_1.getValidKeyword)(modifier, OVERFLOW_KEYWORDS);
        const validAlignment = (0, shared_utils_1.getValidKeyword)(alignment, ALL_ALIGNMENT_VALUES);
        if (validModifier && validAlignment) {
            return { type: 'keyword', keyword: `${validModifier} ${validAlignment}` };
        }
    }
    // Handle multi-word baseline alignment
    if (trimmed.toLowerCase() === 'first baseline' || trimmed.toLowerCase() === 'last baseline') {
        return { type: 'keyword', keyword: trimmed.toLowerCase() };
    }
    // Handle single keywords
    const lowerValue = trimmed.toLowerCase();
    const validKeyword = (0, shared_utils_1.getValidKeyword)(lowerValue, ALL_ALIGNMENT_VALUES);
    if (validKeyword) {
        return { type: 'keyword', keyword: validKeyword };
    }
    return null;
}
function toCSSValue(parsed) {
    if (!parsed) {
        return null;
    }
    // Handle CSS variables
    if ('CSSvariable' in parsed) {
        return (0, css_variable_1.toCSSValue)(parsed);
    }
    if ('keyword' in parsed) {
        return parsed.keyword;
    }
    return null;
}
